<template>
  <transition
    name="page"
    mode="out-in"
  >
    <component
      :is="layout"
      v-if="layout"
    >
      <router-view/>
    </component>
  </transition>
</template>

<script>
import TenancyAdminLayout from "./layouts/tenancy/AdminLayout";
import TenancyPublicLayout from "./layouts/tenancy/PublicLayout";
import TenancyAdminLayoutNoHeader from './layouts/tenancy/AdminLayoutNoHeader'

import CentralAuthorizationLayout from './layouts/central/AuthorizationLayout'
import CentralAuthorizationSsoLayout from './layouts/central/AuthorizationSsoLayout'
import CentralAdminLayout from './layouts/central/AdminLayout'
import CentralPublicLayout from './layouts/central/PublicLayout'
import NoLayout from './layouts/central/NoLayout'
export default {
    name: "App",
    metaInfo() {
        return {
            title: `${this.title} `,
            meta: [
                {
                    vmid: "description",
                    name: 'description',
                    content: `${this.metaDiscription}`,
                },
                {
                    vmid: "og:title",
                    property: 'og:title',
                    content: `${this.metaTitle} : ${this.metaDiscription}`,
                },
                // {
                //     vmid: "og:image",
                //     property: 'og:image',
                //     content: require('@/assets/images/logo.png')
                // },
                {
                    vmid: "og:site_name",
                    property: 'og:site_name',
                    content: `${this.metaTitle}`
                },
                {
                    vmid: "og:type",
                    property: 'og:type',
                    content: 'website'
                },
                {
                    name: 'robots',
                    content: 'index,follow'
                }
            ]
        }
    },
    components: {
        TenancyAdminLayout,
        CentralAuthorizationLayout,
        CentralAuthorizationSsoLayout,
        CentralAdminLayout,
        TenancyPublicLayout,
        TenancyAdminLayoutNoHeader,
        CentralPublicLayout,
        NoLayout
    },
    data() {
        return {
            layout: null,
            defaultLayout: "tenancy-admin-layout",
            defaultMetaTitle: "GOSHIP",
            defaultMetaDiscription: "Shipping software built for eCommerce"
        };
    },
    methods: {
        setLayout(route) {
            if (typeof route == "undefined" || this.layout != null) {
                this.layout = this.defaultLayout;
                document.body.classList.add(this.layout);
            } else {
                this.layout = route;
                document.body.classList.add(this.layout);
            }
        },
    },
    computed: {
        title() {
            if(this.$route.meta.suffix) return this.$t(this.$route.meta.title) + ' - ' + this.$route.meta.suffix;
            if(!this.$route.meta.suffix) return this.$t(this.$route.meta.title)
            return this.$t(this.$route.meta.title) ? this.$t(this.$route.meta.title) : this.defaultMetaTitle
        },
        metaTitle() {
            return this.$route.meta.suffix ? this.$route.meta.suffix : this.defaultMetaTitle;
        },
        metaDiscription() {
            return this.$route.meta.meta_discription ? this.$route.meta.meta_discription : this.defaultMetaDiscription;
        },
    },
    created() {
        this.setLayout(this.$setLayout.meta.layout);
    },
};
</script>


// WEBPACK FOOTER //
// src/App.vue